export default "__VITE_ASSET__CTGrrcOc__"